import React, { useState, ReactNode, Dispatch, SetStateAction } from 'react';

import { createContext, useContext } from 'use-context-selector';
import { ServiceItemProps } from '../models/Service';

export type ServiceContextProps = {
  selectedService: ServiceItemProps;
  setSeletedService: Dispatch<SetStateAction<ServiceItemProps>>;
  clearService: () => void;
  selectedServiceId: string;
  setSelectedServiceId: Dispatch<SetStateAction<string>>;
};

type ServiceProviderProps = {
  children: ReactNode;
};

export const ServiceContext = createContext({} as ServiceContextProps);

export function ServiceProvider({ children }: ServiceProviderProps) {
  const [selectedService, setSeletedService] = useState<ServiceItemProps>({} as ServiceItemProps);
  const [selectedServiceId, setSelectedServiceId] = useState<string>('');

  const clearService = () => {
    // setSeletedService(undefined);
  };

  return (
    <ServiceContext.Provider
      value={{
        selectedService,
        setSeletedService,
        clearService,
        selectedServiceId,
        setSelectedServiceId
      }}
    >
      {children}
    </ServiceContext.Provider>
  );
}

export function useServiceContext() {
  return useContext(ServiceContext);
}
